import { JsonDataItem } from 'types';
import { baseQuery } from '../baseQuery';

export const getCheckEmail = async ({ email, customerType }: JsonDataItem) => {
  const { data } = await baseQuery(`check-email?email=${email}&customer_type=${customerType}`);

  return data;
};
